import { useTranslation } from 'react-i18next';
import { FormProvider } from 'react-hook-form';
import { HomeAddressForm } from '@Pages/happyFlowPages/homeAddress/homeAddressForm/HomeAddressForm.tsx';
import { StepPageWrapper } from '@Layout/StepPageWrapper.tsx';
import { useHomeAddressLogic } from '@Pages/happyFlowPages/homeAddress/hooks/useHomeAddressLogic.ts';
import { useGetCountries } from '@Hooks/api/useGetCountries';
import { RoutesMap } from '@Router/router.types';

interface HomeAddressProps {
  originRoute?: RoutesMap;
}

export const HomeAddress = ({ originRoute = RoutesMap.HOME_ADDRESS }: HomeAddressProps) => {
  const { t } = useTranslation();
  const { data: countriesData } = useGetCountries(true, false);
  const { isPending, formMethods, handleSubmit, countries, states, selectedCountry, isUS } =
    useHomeAddressLogic(countriesData, originRoute);
  const isAuthorizedUser = originRoute === RoutesMap.AUTH_USER_HOME_ADDRESS;
  const text = isUS ? t('pages.homeAddress.text') : t('pages.homeAddress.nonUsText');

  return countriesData ? (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        isLoading={isPending}
        formMethods={formMethods}
        handleSubmit={handleSubmit}
        heading={t('sectionTitles.personalDetails')}
        text={isAuthorizedUser ? undefined : text}
        content={t('pages.homeAddress.content')}>
        <HomeAddressForm
          disabled={false}
          countries={countries}
          states={states}
          selectedCountry={selectedCountry}
          isUS={isUS}
          hideNonUsNote={isAuthorizedUser}
        />
      </StepPageWrapper>
    </FormProvider>
  ) : null;
};
